/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const ApiConsumerService = require('./apiConsumerService');
const ProductApiConsumerService = require('./productApiConsumerService');
const RebateApiConsumerService = require('./rebateApiConsumerService');
const UserApiConsumerService = require('./userApiConsumerService');

const consumersModule = angular
    .module('enervee_utils.consumers', [])
    .factory('ApiConsumerService', ApiConsumerService)
    .factory('ProductApiConsumerService', ProductApiConsumerService)
    .factory('RebateApiConsumerService', RebateApiConsumerService)
    .factory('UserApiConsumerService', UserApiConsumerService);

module.exports = consumersModule;
